// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/vercel/path0/node_modules/dumi/theme-default/slots/ContentTabs/index.js';
